import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Features", href: "#features" },
  { label: "How it works", href: "#how" },
  { label: "Work", href: "#work" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

const LOCKUP_DARK =
  "https://customer-assets-lqy194kg.emergentagent.net/job_groundwork-webapp/artifacts/tdqj8sf0_lockup-dark.webp";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="main-nav"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 border-b-2 border-paper/20 transition-colors duration-300 ${
        scrolled ? "bg-ink/95 backdrop-blur-md" : "bg-ink"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex h-[70px] items-center justify-between">
          <a href="#top" data-testid="nav-logo" className="flex items-center">
            <img src={LOCKUP_DARK} alt="GROUNDWORK" className="h-8 w-auto" />
          </a>

          <nav className="hidden items-center gap-9 md:flex">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.split(" ")[0].toLowerCase()}`}
                className="font-mono text-xs uppercase tracking-[0.18em] text-paper/70 transition-colors duration-200 hover:text-orange"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#download"
              data-testid="nav-cta"
              className="hidden bg-orange px-6 py-3 font-mono text-xs font-bold uppercase tracking-[0.15em] text-paper transition-transform duration-200 hover:-translate-y-0.5 sm:inline-block shadow-brutal-paper"
            >
              Get the app
            </a>
            <button
              data-testid="mobile-menu-toggle"
              className="md:hidden text-paper"
              onClick={() => setOpen((v) => !v)}
              aria-label="Menu"
            >
              {open ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden border-t-2 border-paper/20 bg-ink md:hidden"
          >
            <div className="flex flex-col px-5 py-4">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="border-b border-paper/10 py-4 font-mono text-sm uppercase tracking-[0.15em] text-paper/80"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#download"
                onClick={() => setOpen(false)}
                className="mt-4 bg-orange px-6 py-4 text-center font-mono text-xs font-bold uppercase tracking-[0.15em] text-paper"
              >
                Get the app
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
